import { ActionTree } from 'vuex'
import { ApiVersion, RootState } from '../types'
import { SignInMutations } from './mutations'
import { SignInState, DevicesResponse } from './types'
import firebase from 'firebase/app'
import 'firebase/auth'
import { Response } from '../response'
import UserStorage from '@/utils/Storage/UserStorage'
import { UserData } from '@/utils/Storage/Types'
import router from '@/router'
import axios from 'axios'
import { DeviceRequest, DoctorPayload } from '../doctor/types'
const userStorage = UserStorage.getInstance()

export const actions: ActionTree<SignInState, RootState> = {
  //Signin with Google
  async googleSignIn({ commit, dispatch }) {
    commit(SignInMutations.SET_LOADER, true)
    try {
      const provider = new firebase.auth.GoogleAuthProvider()
      // provider.addScope('https://www.googleapis.com/auth/contacts.readonly')
      firebase.auth().useDeviceLanguage()
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => {
          firebase
            .auth()
            .signInWithPopup(provider)
            .then(async result => {
              const {
                uid,
                email,
                displayName: name,
                photoURL,
                refreshToken
              } = result.user!!
              const token = await result.user?.getIdToken(true)!!
              let expireToken = new Date().getTime()
              expireToken += 3300000

              const userInfo: UserData = {
                token,
                uid,
                email,
                name,
                photoURL,
                refreshToken,
                expireToken
              }
              dispatch('saveUserLocalStorage', userInfo)
            })
        })
    } catch (error: any) {
      console.error(error)
    } finally {
      commit(SignInMutations.SET_LOADER, false)
    }
  },

  async googleRefrehToken() {
    try {
      //TODO reemplazar codigo para api de doctor
      const user = firebase.auth().currentUser
      if (user) {
        const idToken = await user.getIdToken(true)

        const actualUser = await userStorage.getObject()
        if (actualUser) {
          let expireToken = new Date().getTime()
          expireToken += 3300000
          actualUser.token = idToken
          actualUser.expireToken = expireToken
          await userStorage.setObject(actualUser)
          axios.defaults.headers.common.Authorization = `Bearer ${idToken}`
        }
      }
    } catch (error: any) {
      console.log(error.response)
    }
  },

  //Signin with Facebook
  async facebookSignIn({ commit, dispatch }) {
    commit(SignInMutations.SET_LOADER, true)
    try {
      const provider = new firebase.auth.FacebookAuthProvider()
      firebase.auth().useDeviceLanguage()

      await firebase
        .auth()
        .signInWithPopup(provider)
        .then(async result => {
          const { uid, email, displayName: name, photoURL } = result.user!!
          const token = await result.user?.getIdToken()!!

          const userInfo: UserData = {
            token,
            uid,
            email,
            name,
            photoURL
          }

          dispatch('saveUserLocalStorage', userInfo)
        })
    } catch (error: any) {
      console.error(error)
    } finally {
      commit(SignInMutations.SET_LOADER, false)
    }
  },

  //Check if user is registered, register a new user
  // async checkUserExists({ dispatch }, payload: UserData) {
  //   try {
  //     //TODO reemplazar codigo para api de doctor
  //     await axios.get(`${ApiVersion.V1}/Doctor`, {
  //       headers: {
  //         Authorization: `Bearer ${await payload.token}`
  //       }
  //     })
  //     dispatch('saveUserLocalStorage', payload)
  //   } catch (error: any) {
  //     console.log(error.response)
  //     const code: number = error?.response?.status
  //     if (code == HTTPCode.NotFound || code == HTTPCode.Unauthorized) {
  //       //dispatch('registerNewUser', payload)
  //     }
  //   }
  // },

  // //Check if user is registered, register a new user
  // async checkUserExists({ dispatch }, payload: UserData) {
  //   try {
  //     //TODO reemplazar codigo para api de doctor
  //     await axios.get(
  //       'https://gateway.microservices.luminexo.com.mx/api/v2/Users/mainInfo',
  //       {
  //         headers: {
  //           Authorization: `Bearer ${await payload.token}`
  //         }
  //       }
  //     )
  //     dispatch('saveUserLocalStorage', payload)
  //   } catch (error: any) {
  //     console.log(error.response)
  //     const code: number = error?.response?.status
  //     if (code == HTTPCode.NotFound || code == HTTPCode.Unauthorized) {
  //       dispatch('registerNewUser', payload)
  //     }
  //   }
  // },

  // //Register new user
  // async registerNewUser({ dispatch }, payload: UserData) {
  //   try {
  //     const request: UserRequest = {
  //       firebaseUserUid: await payload.token,
  //       name: payload.name,
  //       photoUrl: payload.photoURL,
  //       isPatient: false,
  //       createdBy: '',
  //       email: payload.email
  //     }

  //     await axios.post(`${ApiVersion.V2}/Users`, request, {
  //       headers: {
  //         Authorization: `Bearer ${await payload.token}`
  //       }
  //     })
  //     dispatch('saveUserLocalStorage', payload)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // },

  async saveUserLocalStorage(_, user: UserData) {
    axios.defaults.headers.common.Authorization = `Bearer ${await user.token}`

    userStorage.setObject(user)
    router.replace({ path: '/validate' })
  },

  // Register device
  async registerDevice(_, request: DoctorPayload<DeviceRequest>) {
    try {
      await axios.post(`${ApiVersion.V1}/Doctors/devices`, request.payload)
    } catch (error) {
      console.error(error)
    }
  },

  // Register device
  async getDevices() {
    try {
      const { data } = await axios.get(`${ApiVersion.V1}/Doctors/devices`)
      const response: Response<Array<DevicesResponse>> = data
      return response.data
    } catch (error) {
      console.error(error)
    }
  }
}

// interface UserRequest {
//   firebaseUserUid: string | undefined
//   name: string | null
//   photoUrl: string | null
//   isPatient: boolean
//   createdBy: string | null
//   email: string | null
// }
